export const schedule = {
  "subtitle": "La información visualizada en esta vista se actualizará cada ",
  "5minutes": "5 minutos",
  "upload": "Subir CSV",
  "schedule": "Tipo de programación",
  "scheduleType": "Tipo de frecuencia",
  "points": "Puntos",
  "questions": "Preguntas",
  lastReport: 'Último reporte',
  reportbyList: 'Reporte de visita',
  reportByDetail: 'Reporte de cuestionario',
  reportInform: 'Informe de resultados',
  belongingToSeries: 'Perteneciente a serie {{serie}}',
  deleteQuestionnaire: {
    title: '¿Está seguro que desea borrar el cuestionario?',
    description: 'Una vez se borre el cuestionario <strong>{{name}}</strong> con fecha de inicio <strong>{{init_date}}</strong> ya no se podrán descartar los cambios',
    success: 'El cuestionario se eliminó exitosamente',
    error: 'Ocurrió un error al eliminar el cuestionario',
  },
  closeQuestionnaire: {
    success: 'La visita se canceló de manera exitosa',
    error: 'Ocurrió un error al cancelar la visita',
    successSchedule: 'El agendamiento se cerró de manera exitosa',
    errorSchedule: 'Ocurrió un error al cerrar el agendamiento'
  },
  scheduleTypes: {
    programmed: 'Programada',
    free: 'Libre'
  },
  "menu": {
    "byForm": "Carga desde formulario",
    "byFile": "Carga con archivo"
  },
  questionWithRecurrence: 'Pregunta con reincidencia',
  "assigned": {
    "select": "Confirme la selección de unidades y cuestionarios",
    openQuestionnaire: "Este es un cuestionario libre que no requiere de lapso de fechas",
    "availability": "Indique la disponibilidad del cuestionario",
    "availabilityQuestionnaire": "Configure la fecha y hora de aplicación del cuestionario: {questionnaireName} para el usuario: {userName}",
    "availabilityAllQuestionnaire": "Configure la fecha y hora de aplicación para todos los cuestionarios y usuarios seleccionados.",
    "detailAvailability": "Detalle de la visita",
    "detailPlanification": "Información de la planificación",
    "from": "Desde",
    "to": "Hasta",
    "frequency": "Frecuencia",
    "selectedTherequency": "Seleccione la frecuencia",
    "every": "Cada",
    "storeInfo": "Información de la unidad",
    "sendAlert": "Enviar alerta de vencimiento",
    "sendAlertToAdmin": "Enviar notificaciones al administrador",
    "availablefromOne": "Disponible desde el {{startDate}} a la {{startHour}} hasta el {{endDate}} a la {{endHour}}",
    "availablefromOnlyOne": "Disponible desde el {{startDate}} a la {{startHour}} hasta el {{endDate}} a las {{endHour}}",
    "availablefromOnlyTwo": "Disponible desde el {{startDate}} a las {{startHour}} hasta el {{endDate}} a la {{endHour}}",
    "availablefromTow": "Disponible desde el {{startDate}} a las {{startHour}} hasta el {{endDate}} a las {{endHour}}",
    "availableEveryDayFromOne": "Disponible cada día desde la {{startHour}} hasta la {{endHour}}",
    "availableEveryDayFromOnlyOne": "Disponible cada día desde la {{startHour}} hasta las {{endHour}}",
    "availableEveryDayFromOnlyTwo": "Disponible cada día desde las {{startHour}} hasta la {{endHour}}",
    "availableEveryDayFromTwo": "Disponible cada día desde las {{startHour}} hasta las {{endHour}}",
    "generatedEvery": "Generado cada {{days}}",
    "generatedEveryEdit": "Cada {{days}}",
    "initialGeneration": "La generación inicia el {{startDate}} hasta el {{endDate}}",
    "initialGenerationEdit": "Iniciando el {{startDate}} hasta el {{endDate}}",
    "eachSchedulingAvailableDuring_one": "Cada agendamiento disponible durante {{dayAvailable}} día hábil, considerando los días {{days}} ",
    "eachSchedulingAvailableDuring_other": "Cada agendamiento disponible durante {{dayAvailable}} días hábiles, considerando los días {{days}} ",
    "generatedEveryFrom": "Generado cada {{day}} desde el {{startDate}} hasta el {{endDate}}",
    "generatedEveryFromEdit": "Cada {{day}} desde el {{startDate}} hasta el {{endDate}}",
    "generatedConsecutively": "Generado consecutivamente desde el {{startDate}} hasta el {{endDate}}",
    "generatedConsecutivelyEdit": "Consecutivamente desde el {{startDate}} hasta el {{endDate}}",
    "singlSscheduling": "Agendamiento único",
    "freeScheduling": "Agendamiento libre",
    "dailyScheduling": "Agendamiento diario",
    "weeklyScheduling": "Agendamiento semanal",
    "cyclicalScheduling": "Agendamiento cíclico",
    "sendAlertSecond": "Notificar vencimiento",
    "sendAlertToAdminSecond": "Notificar al administrador",
    "schedulingPlanning": "Planificación de agendamiento",
    "notification": "Notificaciones",
    "schedulingType": "Tipo de agendamiento",
    "visit": "Visita",
    "unity": "Unidad",
    "questionarie": "Cuestionario",
    "programmed": "Programado",
    "free": "Libre",
    "availabilitySchedule": "Disponibilidad",
    "availabilityByCalendar": "Disponibilidad por agendamiento",
    "storeListing": "Listado de unidades",
    "selectedStores": "Unidades seleccionadas",
    "selectedQuestionnaires": "Cuestionarios a aplicar",
    "newPlanification": "Nueva planificación",
    "backToList": "Regresar al listado",
    "backToEdit": "Regresar a la edición",
    "calendarCreate": "Creación de agendamiento",
    "calendarEdit": "Editar agendamiento",
    "editCalendarSeries": "Editar serie de agendamientos",
    "calendarToOneOrMany": "Establezca la planificación de uno o muchos agendamientos",
    "calendarToOne": "Establezca la planificación de un agendamiento",
    "frecuencyDailyDescription": "La duración de la agenda diaria no puede exceder el límite permitido de 24 horas.",
    "everyDay": "Cada*",
    "businessDay": "Días hábiles*",
    "rangeOfTheSeries": "Rango de la serie",
    "theExecutionIsAvailableFrom": "La ejecución estará disponible durante",
    "executionAvailabe_one": " {{amount}} día hábil",
    "executionAvailabe_other": " {{amount}} días hábiles",
    "editPlanification": "Editar planificación",
    "doYouNeedSelectedAlLeastOneQ": "Debes seleccionar al menos un cuestionario para continuar",
    "doYouNeedSelectedAlLeastOneS": "Debes seleccionar al menos una unidad para continuar",
    "doYouNeedSelectedAlLeastOneU": "Debes seleccionar al menos un usuario para continuar"
  },
  "tables": {
    "userAssigned": "Usuario asignado",
    "unity": "Unidad",
    "questionarie": "Cuestionario",
    "frequency": "Frecuencia"
  },
  "bodySection": {
    "planningInformation": "Info. planificación",
    "reporting": "Reportería",
    "supervisors": 'Supervisores'
  },
  "filter": {
    "title": "Agenda por unidad",
    "filterTitle": "FILTRAR POR",
    "inputs": {
      "search": "Buscar agenda",
      "firstSelect": "Estatus de la agenda"
    },
    "filterStore": {
      "title": "Seleccione las unidades para las que realiza esta planificación",
      "titleOnlyOne": "Selección de unidad",
      "search": "Buscar unidades"
    },
    "filterQuestionnaire": {
      "title": "Seleccione los cuestionarios que se deben aplicar en esta planificación",
      "titleOnlyOne": "Selección de cuestionario",
      "search": "Buscar cuestionario"
    }
  },
  "snackbar": {
    selectAtLeastOneSchedule: "Debes seleccionar al menos un agendamiento para realizar esta acción",
    'generateScheduleDownload_pdf':'Generando descarga de agendamientos por unidad en pdf',
    'generateScheduleDownload_word':'Generando descarga de agendamientos por unidad en word',
    'generateScheduleDownload_excel':'Generando descarga de agendamientos por unidad en excel',
    "delete": {
      "error": {
        "unique": "No se pudo eliminar el agendamiento.",
        "serie": "No se pudo eliminar la serie de agendamientos.",
        "masive_one": "No se pudo eliminar el agendamiento seleccionado.",
        "masive_other": "No se pudieron eliminar los agendamientos seleccionados."
      },
      "success": {
        "unique": "El agendamiento fue eliminado correctamente.",
        "serie": "La serie de agendamientos fue eliminada correctamente.",
        "masive_one": "El agendamiento seleccionado se eliminó correctamente.",
        "masive_other": "Los agendamientos seleccionados fueron eliminados correctamente."
      }
    },
    "download": {
      "error": {
        "pdf": "Ocurrió un error en la descarga del documento",
        "csv": "",
        "word": ""
      }
    }
  },
  "modal": {
    "displayReport": "Ver reporte",
    "editSuccessSchedule": "El agendamiento se editó exitosamente",
    "editSuccessSerie": "La serie se editó exitosamente",
    "areYouSureWantDeleteAllSchedulingForTheSeries": "¿Estás seguro que deseas eliminar todos los agendamientos de la serie?",
    "areYouSureWantDeleteAllSchedulingSelected_one": "¿Estás seguro que deseas eliminar el agendamiento seleccionado?",
    "areYouSureWantDeleteAllSchedulingSelected_other": "¿Estás seguro que deseas eliminar todos los agendamientos seleccionados?",
    "saveConfiguration": "¿Estás seguro que deseas aplicar la siguiente configuración?",
    "areYouSureToEditThisSchedule": "¿Estás seguro que deseas editar este agendamiento?",
    "areYouSureToEditThisSerie": "¿Estás seguro que deseas aplicar la siguiente configuración de frecuencia para toda la serie?",
    "confirmation": "Confirmación",
    "backToTheList": "Regresar al listado",
    "sureBackToTheList": "¿Estás seguro de que deseas regresar al listado? Los cambios no guardados se perderán.",
    "cancelEdition": "Cancelar edición",
    "cancelEditionDescription": "¿Estás seguro de que deseas cancelar la edición? Los cambios no guardados se perderán.",
    "resendReport": "Reenviar reporte",
    "displayQuestionnaireReport": "Ver reporte",
    "resendQuestionnaireReport": "Reenviar reporte",
    "displayQuestionnaireResultReport": "Ver informe de resultados",
    "resendQuestionnaireResultReport": "Reenviar informe de resultados",
    "edit": "Editar planificación",
    "cancel": "Cancelar visita",
    "wantClose": "¿Está seguro que desea cancelar la visita?",
    "deleteSchedule": "Eliminar agendamiento",
    "deleteScheduleDescription": "¿Estás seguro que deseas eliminar este agendamiento?",
    "deleteScheduleSerie": "Eliminar serie de agendamiento",
    "deleteScheduleDescriptionSerie": "¿Estás seguro que deseas eliminar toda la serie de agendamientos?",
    "descriptionClose": "Una vez se cancele la visita ya no se podrá activar o editar",
    "wantCloseSchedule": "¿Está seguro que desea cerrar el agendamiento?",
    "descriptionCloseSchedule": "Una vez se cierre el agendamiento ya no se podrá activar o editar",
    "submit": {
      "title": "¿Está seguro que desea generar esta planificación?",
      "description": "",
      "titleUpdate": "¿Está seguro que desea actualizar esta planificación?",
      "descriptionUpdate": "Una vez aplicado los cambios, estos se verán reflejados en un plazo 5 minutos"
    }
  },
  "errors": {
    questionnaireWithPermissions: "Cuestionarios con permisos",
    questionnaireWitoutPermissions: "Cuestionarios sin permisos",
    duplicates: "Duplicados",
    noDuplicates: "No duplicados",
    duplicity: "Errores de duplicidad",
    permissions: "Se encontraron errores",
    questionnairesAssigned: "Cuestionarios asignados",
    "create": "Ocurrió un error inesperado al crear la visita",
    "success": "La planificación de la visita se creó con éxito",
    "updateSuccess": "La planificación de la visita se actualizó con éxito",
    "updateError": "Ocurrió un error inesperado al actualizar la visita",
    "noComments": "No se encuentran comentarios"
  },
  "buttons": {
    "addScheduled": "Agregar visita",
    "selectOtherQuestionarie": "Seleccionar otro cuestionario",
    "selectOtherUnity": "Seleccionar otra unidad",
    "updateScheduled": "Actualizar visita",
    "addTruechecket": "Marcar todos",
    "addFalsechecket": "Desmarcar todos",
    "returnToQuestionnaireDetail": "Regresar al detalle de cuestionario",
    "expandAll": "Expandir todo",
    "collapseAll": "Contraer todo",
    "downloadEvidence": "Descargar evidencias",
    "download": 'Descargar',
    "view": 'Ver evidencias',
    "sendComment": "Agregar comentario",
    "cancelComment": "Cancelar comentario"
  },
  detail: {
    title: 'Cuestionarios ejecutados en esta visita',
    'questionnaireExecution': 'EJECUCIÓN DEL CUESTIONARIO'
  }
}